export const windowMaxWidth = 'xs:max-w-[97.5%]';
